import { jsx } from 'react/jsx-runtime';

function InputHint(_ref) {
  let {
    className,
    hint
  } = _ref;
  if (!hint) {
    return null;
  }
  return jsx("small", {
    className: className,
    children: hint
  });
}

export { InputHint };
